import { render, staticRenderFns } from "./RecipeImages.vue?vue&type=template&id=0ca1499b&"
import script from "./RecipeImages.vue?vue&type=script&lang=ts&"
export * from "./RecipeImages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports